import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {makePostRequest} from '@ibibo/myaccount-reducer';
import {saveTravelGstUrl} from '../../../../../../shared/CommonConfigs/url';
import * as S from '../AddGstModal/AddGstModal.styles';
import {logOmniClick} from '@ibibo/analytics';
import useGstForm from '../../../../../../shared/hooks/useForm';
import withFormField from '../../../../../../shared/HOC/withFormField';
import {gstOwnerOptions, indianStates} from '../data';
import Spinner from '../../../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/Spinner/Spinner';

// HOC wrapped form fields
const InputField = withFormField(S.gstModlInput);

const AddGstModal = ({initialFormValues, setModalDimenstions}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [respMessage, setRespMessage] = useState({
    error: '',
    success: '',
  });

  // Define default values for the form fields
  const defaultValues = Object.keys(initialFormValues).length
    ? initialFormValues
    : {
        gstOwner: '',
        gstNumber: '',
        billingAddress: '',
        companyName: '',
        state: '',
        pinCode: '',
        isDefault: false,
      };

  // Use the custom form hook
  const {register, handleSubmit, errors, onSubmit} = useGstForm({defaultValues, onSubmitHandler});

  function onSubmitHandler(data) {
    setIsLoading(true);
    const transformedData = {
      ...data,
      isDefault: data.isDefault ? 1 : 0,
    };

    logOmniClick('mysettings:gst', {
      prop54: `CTA –Save_GST_Clicked `,
    });

    dispatch(
      makePostRequest(
        saveTravelGstUrl,
        {...transformedData},
        () => {
          setIsLoading(false);
          setRespMessage({error: '', success: 'Congratulations! GST details saved successfully'});
          setModalDimenstions(true);
          setTimeout(() => {
            window.location.href = '/mysettings';
          }, 2500);
        },
        (resp, data) => {
          setIsLoading(false);
          setRespMessage({error: resp?.error?.errorMessage, success: ''});
        },
      ),
    );
  }

  return !respMessage.success.length ? (
    <S.gstModalWrap>
      <form onSubmit={handleSubmit(onSubmit)}>
        <p className="gstMdlHeading">Add GST Number Details</p>
        <p className="gstModalSubHeading">
          Add details of your travel agency's or client’s GST to save them for reuse
        </p>

        <div className="inputRow">
          <S.gstModlInputWrap flex="1">
            <p className="inputMdlLabel">GST Owner *</p>
            <InputField
              name="gstOwner"
              register={register}
              errors={errors}
              placeholder="Select GST Owner (Self/Client)"
              type="select"
              className={'dropdownClass'}
              options={gstOwnerOptions}
              {...register('gstOwner', {required: 'GST Owner is required'})}
            />
          </S.gstModlInputWrap>

          <S.gstModlInputWrap flex="1" margin="0px 0px 0px 10px">
            <p className="inputMdlLabel">GST Number *</p>
            <InputField
              name="gstNumber"
              register={register}
              errors={errors}
              width={'100%'}
              placeholder="Enter GST Number"
              {...register('gstNumber', {
                required: 'GST Number is required',
                pattern: {
                  value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                  message: 'Invalid GST Number format',
                },
              })}
            />
          </S.gstModlInputWrap>
        </div>

        <div className="inputRow">
          <S.gstModlInputWrap flex="1">
            <p className="inputMdlLabel">Billing Address*</p>
            <InputField
              name="billingAddress"
              register={register}
              errors={errors}
              width="100%"
              placeholder="Enter billing address"
              {...register('billingAddress', {
                required: 'Billing Address is required',
                maxLength: {
                  value: 200,
                  message: 'Billing Address cannot exceed 200 characters',
                },
              })}
            />
          </S.gstModlInputWrap>
        </div>

        <div className="inputRow">
          <S.gstModlInputWrap flex="1">
            <p className="inputMdlLabel">Company Name *</p>
            <InputField
              name="companyName"
              register={register}
              errors={errors}
              width="100%"
              placeholder="Less than 50 characters"
              {...register('companyName', {
                required: 'Company Name is required',
                maxLength: {
                  value: 50,
                  message: 'Company Name cannot exceed 50 characters',
                },
              })}
            />
          </S.gstModlInputWrap>
        </div>

        <div className="inputRow">
          <S.gstModlInputWrap flex="1">
            <p className="inputMdlLabel">State *</p>
            <InputField
              name="state"
              register={register}
              errors={errors}
              placeholder="Enter State"
              type="select"
              className={'dropdownClass'}
              options={indianStates}
              {...register('state', {required: 'State is required'})}
            />
          </S.gstModlInputWrap>

          <S.gstModlInputWrap flex="1" margin="0px 0px 0px 10px">
            <p className="inputMdlLabel">Pin Code*</p>
            <InputField
              name="pinCode"
              register={register}
              errors={errors}
              placeholder="Enter Pin Code"
              width={'100%'}
              {...register('pinCode', {
                required: 'Pin Code is required',
                pattern: {
                  value: /^[1-9][0-9]{5}$/,
                  message: 'Invalid Pin Code format',
                },
              })}
            />
          </S.gstModlInputWrap>
        </div>
        <div className="makeFlex appendTop">
          <span className="">
            <InputField
              type="checkbox"
              name="isDefault"
              label="Mark as default"
              register={register}
              errors={errors}
              className={'checkboxClass'}
              {...register('isDefault', {})}
            />
          </span>
        </div>

        {!isLoading ? (
          <S.gstModalCta width="100%" backgroundColor="#008cff" color="#FFF" type="submit">
            Save Details
          </S.gstModalCta>
        ) : (
          <S.gstModalCtaLoader>
            <Spinner width="32px" height="32px" />
          </S.gstModalCtaLoader>
        )}
        {respMessage.error?.length > 0 && <p className="error">{respMessage.error}</p>}
      </form>
    </S.gstModalWrap>
  ) : (
    <S.GstModalSuccessWrap>
      <p className="gstMdlHeading">{respMessage?.success}</p>
    </S.GstModalSuccessWrap>
  );
};

export default AddGstModal;
